import React from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import ImageUpload from '@/components/ImageUpload';
import ColorInput from '@/components/ColorInput';
import config from 'config';
import WidgetOptionsForm from './WidgetOptionsForm';
import WidgetOptionGroupPermissions from './WidgetOptionGroupPermissions';

const DividerWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		handlePropChange,
		handleGroupChange,
		targetKeys,
	} = props;
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	return (
		<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
			<Form.Item label="Divider Type" name="type">
				<Toggle toggleOptions={['solid', 'dashed', 'custom']} />
			</Form.Item>
			{widgetProps.type === 'custom' ? (
				<Form.Item label="Divider Source" name="source">
					<ImageUpload endpoint={signedUrlEndpoint} imageObj={true} />
				</Form.Item>
			) : (
				<>
					<Form.Item label="Divider Size" name="size">
						<Toggle toggleOptions={['small', 'medium', 'large']} />
					</Form.Item>
					<Form.Item label="Divider Color" name="color">
						<ColorInput
							color={widgetProps.color}
							onChange={hex => handlePropChange('color')(hex)}
							eventID={event.id}
						/>
					</Form.Item>
				</>
			)}
			<WidgetOptionGroupPermissions
				event={event}
				handleGroupChange={handleGroupChange}
				targetKeys={targetKeys}
			/>
		</WidgetOptionsForm>
	);
};

export default DividerWidgetOptions;
